import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment as env } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { acceptJsonInterceptor } from './shared/interceptors/accept-json.interceptor';
import { dateInterceptor } from './shared/interceptors/date.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAuth0({
      ...env.auth,
      httpInterceptor: {
        ...env.httpInterceptor,
      },
    }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([acceptJsonInterceptor, dateInterceptor])
    ),
  ],
};
